import { useIntl } from 'react-intl';

import Lozenge from '@atlaskit/lozenge';

import { messages } from './lozenges.i18n';

export const BetaLozenge = ({ isBold = false }: { isBold?: boolean }) => {
  const { formatMessage } = useIntl();
  return (
    <Lozenge appearance="new" isBold={isBold}>
      {formatMessage(messages.beta)}
    </Lozenge>
  );
};
